import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";
import { categories } from "@/mocks/categories";

export default function Categories() {
  return (
    <section id="categorias" className="w-full scroll-mt-24 bg-background-50" aria-label="Categorias em destaque">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-7xl">
          <SectionHeading
            eyebrow="Categorias em destaque"
            title="Encontre o seu estilo"
            text="Escolha uma categoria que combine com o seu momento e descubra novas possibilidades para o seu guarda-roupa."
          />

          <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            {categories.map((category, index) => {
              const to = category.id === "novidades" ? "/novidades" : `/categoria/${category.id}`;
              return (
                <Reveal key={category.id} delay={(index % 4) * 80}>
                  <article className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
                    <div className="relative h-[360px] w-full overflow-hidden md:h-[420px]">
                      <img
                        src={category.image}
                        alt={`Categoria ${category.name} — moda feminina Amora Belle`}
                        title={`${category.name} — moda feminina Amora Belle`}
                        className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent" />
                      <div className="absolute inset-x-0 bottom-0 p-5">
                        <h3 className="font-heading text-2xl text-background-50">{category.name}</h3>
                        <p className="mt-1 text-xs leading-relaxed text-background-200">
                          {category.tagline}
                        </p>
                        <Link
                          to={to}
                          className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-background-50/95 px-4 py-2 text-xs font-medium text-foreground-900 transition-colors hover:bg-accent-100"
                        >
                          Ver
                          <i className="ri-arrow-right-line text-sm" />
                        </Link>
                      </div>
                    </div>
                  </article>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}